import React, { useCallback, useEffect, useState } from 'react';
import {
  Loader,
  ScrollableDynamicTable,
  SearchBox,
  TOAST as Alert,
  Navigation,
  Button,
  TOAST,
} from 'retro';
import { get } from 'App/Network/Axios';
import OpenIcon from '@atlaskit/icon/glyph/open';
import ViewRequest from './RefundRequest';
import moment from 'moment';
import { DownloadCsv } from 'retro/Utils';
import RBAC from 'App/HOCs/RBAC';
import ROLES from 'App/Constants/Roles';
import FilterDropDown from 'App/Components/Filter/FilterDropDown';
import Filter from 'retro/Filter';

export default function index() {
  let [loading, setLoading] = useState(true);
  const [id, setId] = useState(undefined);
  const [search, setSearch] = useState({
    page: 0,
    sort: 'id',
    order: 'desc',
  });
  const [Data, SetData] = useState({
    total: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
  });
  const [filterModal,setFilterModal] = useState(false);
	const [filter, setFilter] = useState({
		client: [],
    checkin: []
	});
  // const loadPage = useCallback(
  //   (search) => {
  //     get(
  //       `/meta/hotel/queue/refunding`,
  //       (e, r) => {
  //         if (r) {
  //           SetData({
  //             ...r,
  //             total: r.total || Data.total,
  //             totalPages: r.totalPages || Data.totalPages,
  //           });
  //           setLoading(false);
  //         } else {
  //           Alert.handleError(e);
  //         }
  //       },
  //       {
  //         offset: search.page,
  //         order: search.order,
  //         q: search.q,
  //       }
  //     );
  //   },
  //   [Data, SetData]
  // );
  const loadPage = useCallback(
    (search) => {
	  	const clientIds = filter.client.map(client => client.id);

      get(
        `/meta/hotel/queue/refunding`,
        (e, r) => {
          if (r) {
            SetData({
              ...r,
              total: r.total || Data.total,
              totalPages: r.totalPages || Data.totalPages,
            });
            setLoading(false);
          } else {
            Alert.handleError(e);
          }
        },
        {
          offset: search.page,
          order: search.order,
          q: search.q,
          clientIds: clientIds.length > 0 ? clientIds : undefined,
          start: filter.checkin.length > 0 ?
              filter.checkin[0] === 'Upcoming 24 hours' ?
                moment().valueOf().toString() : moment().add(24, 'hours').valueOf().toString()
              : undefined,
          end: filter.checkin.length > 0 ?
            filter.checkin[0] === 'Upcoming 24 hours' ? moment().add(24, 'hours').valueOf().toString() : moment().add(48, 'hours').valueOf().toString()
            : undefined,
        }
      );
    },
    [Data, SetData, filter.client, filter.checkin]
  );
 
  useEffect(() => {
    loadPage(search);
  }, [search, filter.client, filter.checkin]);
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className='mb2 relative'>
        <Navigation title='Request History' />
        <RBAC role={ROLES.REPORTS}>
          <Button
            onClick={() => {
              setLoading(true);
              get(`/meta/hotel/queue/refunding/all`, (e, r) => {
                if(e){
                  // TOAST.error(e);
                  console.log(e);
                }
                if (r) {
                  let data = [];
                  const headers = [
                    'Transaction Id',
                    'City',
                    'Hotel Name',
                    'Hotel Address',
                    'Status',
                    'Client Code',
                    'Guest Name',
                    'Guest Email',
                    'Travel Date',
                    'Request Date',
                  ];
                  data.push(headers);
                  r.items.forEach((item) => {
                    let line = [];
                    line.push([item.transId]);
                    line.push([item.hotel?.city || '-']);
                    line.push([item.hotel?.name || '-']);
                    line.push([item.hotel?.address || '-']);
                    line.push([item.status]);
                    line.push([item.client.clientCode]);
                    line.push([item.guests?.[0]?.name]);
                    line.push([item.guests?.[0]?.email]);
                    line.push([
                      `${item.stayDetails?.checkIn} - ${item.stayDetails?.checkOut}`,
                    ]);
                    line.push([
                      moment(item.createdAt).format('DD MMM YYYY HH:mm a'),
                    ]);
                    data.push(line);
                  });
                  DownloadCsv(
                    `refund_queue${moment().format('DD_MM_YYYY')}}.csv`,
                    data
                  );
                }
                setLoading(false);
              });
            }}
            loading={loading}
            className='btn btn-primary btn-sm absolute top-2 right-0'
            style={{ zIndex: 10 }}
          >
            <i className='fa fa-download mr1' />
            Download Data
          </Button>
        </RBAC>
      </div>
      <Filter
			margin="0 -4rem"
			onSearch={(q) => {
				setSearch({
					...search,
					page: 0,
					q,
				})
			}}
			onFilter={() => {
				setFilterModal(true)
			}} 
		/>

		<FilterDropDown
			shown={filterModal}
			filters={filter}
			setFilters={setFilter}
			choices={{
				client: [],
        checkin: [
          {
            title: 'Upcoming 24 hours',
            type: 'radio'
          },
          {
            title: 'Upcoming 48 hours',
            type: 'radio'
          }
        ]
			}}
			types={["Client", "CheckIn"]}
			onClose={() => {
				setFilterModal(false);
			}}
		/>
      {/* <SearchBox
        onChange={(q) => {
          setSearch({
            ...search,
            page: 0,
            q,
          });
        }}
        placeholder='Enter your search criteria'
      /> */}
      <ScrollableDynamicTable
        setSearch={(search) => {
          setSearch({
            ...search,
            page: 0,
          });
        }}
        search={search}
        tableStyle={{
          borderSpacing: 0,
        }}
        setPage={(page) => {
          setSearch({
            ...search,
            page,
          });
        }}
        data={{
          current: Data.currentPage,
          total: Data.totalPages,
          items: Data.items.map((item) => {
            const click = () => {
              setId(item.queueId);
            };
            return {
              content: item,
              render: [
                {
                  children: (
                    <div>
                      <p className='text fw-bold'>{item.transId}</p>
                      <p className="text">{item.referenceId || '-'}</p>
                      <p className='text'>{item.hotel?.city || '-'}</p>

                      <p className='text-small text-light'>
                        {item.hotel?.name || '-'}
                      </p>
                      <p className='text-small text-light'>
                        {item.hotel?.address || '-'}
                      </p>
                    </div>
                  ),
                  weight: 1.5,
                },
                {
                  weight: 1,
                  title: moment(item.createdAt).format('DD MMM YYYY HH:mm a'),
                },
                {
                  weight: 1,
                  buttons: [
                    {
                      title: 'View',
                      className: 'btn-secondary btn-sm',
                      before: <OpenIcon size='small' />,
                      onClick: click,
                    },
                  ],
                  actions: [
                    {
                      title: 'Quick Actions',
                      actions: [
                        {
                          title: 'View',
                          before: <OpenIcon size='small' />,
                          onClick: click,
                        },
                      ],
                    },
                  ],
                },
              ],
            };
          }),
        }}
        headers={[
          {
            weight: 1.5,
            title: 'Details',
          },
          {
            weight: 1,
            title: 'Request Date',
          },
          {
            weight: 1,
            title: 'Actions',
            style: {
              justifyContent: 'end',
            },
          },
        ]}
      />
      {id !== undefined && (
        <ViewRequest
          id={id}
          onClose={() => {
            setId(undefined);
            loadPage(search);
          }}
        />
      )}
    </div>
  );
}
